$bog_ainews_app_favorites $bog_ainews_app_feed
	title @ \Favorites
	category_title* \ 
	add_post? null
	remove_post? null
	posts /
